import * as util from "./util.js"
import axios from "axios";

async function init() {
    if (window.FB != null)
        return;
    await util.loadScript("https://connect.facebook.net/en_US/sdk.js");
    window.FB.init({
        appId: '898956330585949',
        version: 'v5.0',
        cookie: true,
        xfbml: true
    });
}

function fbStatus() {
    return new Promise((resolve) => {
        window.FB.getLoginStatus(resolve);
    });
}

function fbLogin() {
    return new Promise((resolve) => {
        window.FB.login(resolve, {
            scope: 'email,public_profile',
            return_scopes: true
        });
    });
}
export async function login(kingdomId, worldId) {
    await init();
    var response;
    response = await fbLogin();
    if (response.status === 'connected') {
        let token = response.authResponse.accessToken;

        let payload = {token: token, authType: 'facebook', fromKlay: {kingdomId: kingdomId, worldId: worldId}};

        let ret = await axios.post(
            `https://lok-api-live.leagueofkingdoms.com/api/auth/login`,
            {json: JSON.stringify(payload)}
        );

        console.log(ret);

        if (ret.data.result == false) {
            alert("이미 글로벌 서버에 있는 계정입니다. 다른 계정으로 시도해 주세요.")
        }
        else {
            location.reload();
        }
    }        
}
export async function share(data) {
    let parse = data.split("^");
    window.FB.ui({
        display: 'popup',
        method: 'share',
        href: parse[0],
        quote: parse[1],
        hashtag: parse[2],
    }, function (response) { });
}
export async function logout() {
    await init();
    window.FB.logout(response => {
    });
}